<template>
  <div class="footer">
    <b-container>
      <b-row>
        <b-col class="footer_text" lg="6" xl="6" sm="12">
          Copyright © 2020 - Alexandre Grisey, coach et formateur en télétravail
        </b-col>
        <b-col class="footer_links" lg="6" xl="6" sm="12">
          <a href="/#presentation">
            Accueil
          </a>
		  |
		  <a href="/formation">
            Formation & coaching
          </a>
		  |
		  <a href="/#contact">
            Contact
          </a>
		  |
		  <a href="/#whoami">
            Qui suis-je ?
          </a>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
